const styles = {
    avatarStyle: {
        marginBottom: 15,
        marginLeft: 15,
    },
    cardBackgroundImage: {
        alignItems: 'flex-end',
        backgroundImage: 'url(http://via.placeholder.com/350x150)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderColor: '#938F93',
        borderStyle: 'solid',
        borderWidth: 1,
        display: 'flex',
        flex: 1,
        height: 'auto',
        justifyContent: 'space-between',
        width: 'auto',
    },
    cardButtonOption: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 20,
        marginLeft: 15,
        // TODO: HIDE ON MOBILE
        textShadow: '0px 0px 3px rgba(0,0,0,0.7)'
    },
    cardButtonOptionContainer: {
        marginBottom: 15,
        marginRight: 15,
    },
    cardMainTitle: {
        color: '#5C5C5C',
        fontFamily: 'Open Sans',
        fontSize: 22.6,
        fontWeight: '700',
        marginTop: -5,
        textTransform: 'Capitalize'
    },
    cardSubTitle: {
        color: '#5C5C5C',
        fontFamily: 'Nunito',
        fontSize: 20,
        fontWeight: '200',
    },
    cardTypeTitle: {
        color: '#938F93',
        fontFamily: 'Open Sans',
        fontSize: 16,
        fontWeight: '600',
        letterSpacing: 1.5,
        marginTop: 5,
        textTransform: 'uppercase',
    },
    container: {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: 30
    },
}

export { styles as cardStyles };


// WEBPACK FOOTER //
// ./src/js/components/Card/styles.ts